const PERCENT = /^\d+(?:\.\d{1,2})?$/;
const SOURCE_EVALUATORS = new Set(['daily-rules-v2', 'daily-rules-v3', 'custom-daily-rules-v3']);

export const protectiveSettingsFromDefinition = (definition) => {
  const configuration = definition?.canonical_configuration;
  if (configuration?.evaluator_version !== 'protective-composite-v1'
    || configuration?.strategy_schema_version !== '4.0'
    || !SOURCE_EVALUATORS.has(configuration?.source_configuration?.evaluator_version)
    || !configuration?.source_definition_id
    || !/^[0-9a-f]{64}$/.test(configuration?.source_strategy_hash || '')) return null;
  const exits = configuration.protective_exits;
  if (!exits || typeof exits !== 'object') return null;
  const keys = ['loss_guard', 'profit_target', 'profit_trail'];
  if (keys.some((key) => exits[key] !== null
    && (!PERCENT.test(String(exits[key])) || Number(exits[key]) < 0.01 || Number(exits[key]) > 99.99))) return null;
  if (keys.every((key) => exits[key] == null)) return null;
  return {
    sourceFamily: configuration.source_configuration.strategy_family,
    loss_guard: exits.loss_guard,
    profit_target: exits.profit_target,
    profit_trail: exits.profit_trail,
  };
};
